import React from 'react';
import { columnWithTooltip } from 'src/presentation/components/pages/shared/Table';
import EmailDomainStateComponent from 'src/presentation/components/pages/email/components/EmailDomainStateComponent';

export const DOMAINS_TAB_KEY = 'domains';
export const ADDRESSES_TAB_KEY = 'addresses';

export const SEARCH_MAP = {
  [DOMAINS_TAB_KEY]: ['content.customerDomain', 'content.state', 'createdByString'],
  [ADDRESSES_TAB_KEY]: ['address', 'senderName'],
};

export const EMAIL_ADDRESSES_COLUMN_CONFIG = [
  { attr: 'address', label: 'Email address' },
  { attr: 'senderName', label: 'Sender name' },
  { attr: 'entryPointInbox', label: 'Entry point inbox' },
  { attr: 'createdByString', label: 'Created by' },
  {
    attr: 'createdAtString',
    label: 'Created on',
  },
];

export const DOMAINS_COLUMN_CONFIG = [
  { attr: 'content.customerDomain', label: 'Domain' },
  {
    attr: 'content.state',
    label: 'Status',
    customColumnRender: columnWithTooltip({
      dataAid: 'status-tooltip',
      message: (
        <span data-aid="status-tooltip-text">
          Unverified means that the DNS records
          <br /> for your sending domain have not yet been updated.
          <br /> Verified means that your sending domain
          <br /> is ready to use.
        </span>
      ),
    }),
    customRenderer: ({ content }) => <EmailDomainStateComponent state={content.state} />,
  },
  { attr: 'createdByString', label: 'Created By' },
  {
    attr: 'createdAtString',
    label: 'Created On',
  },
];

export enum EmailSetupModal {
  NONE,
  ADD_DOMAIN_WIZARD,
  ADD_EMAIL_ADDRESS_WIZARD,
  DNS_RECORDS,
  EDIT_EMAIL_ADDRESS_WIZARD,
  VIEW_FORWARDING_EMAIL_ADDRESS,
}
